<template>
  <form @submit.prevent="onSearch" class="mt-3" v-if="coachDropdown && coachDropdown.length">
    <div class="row">
      <div class="col-lg-4 col-md-8 col-sm-12">
        <SelectVue
            v-model="filters.coachId"
            :options="coachDropdown"
            :is-clear="true"
            :placeholder="$t('placeholder.coach')"/>
      </div>
      <div class="col-lg-2 col-md-4 col-sm-12">
        <div v-if="statusDropdown && statusDropdown.length">
          <SelectVue
              v-model="filters.status"
              :options="statusDropdown"
              :is-clear="true"
              :placeholder="$t('placeholder.status')"/>
        </div>
      </div>
      <div class="col-lg-2 col-md-4 col-sm-12">
        <BaseInput
            v-model="filters.billNumber"
            :placeholder="$t('placeholder.bill_number')"/>
      </div>
      <div class="col-lg-2 col-md-12 col-12 order-last order-lg-0 text-center text-lg-start mb-3 mb-lg-0">
        <SearchButton
            type="submit"
            :label="$t('general.button.search')"
            :loading="loading"/>
      </div>

      <div class="w-100 d-none d-lg-block"></div>

      <div class="col-lg-2 col-md-4 col-sm-12">
        <Datepicker
            v-model="filters.startDate"
            position="down"
            :placeholder="$t('placeholder.start_date')"/>
      </div>
      <div class="col-lg-2 col-md-4 col-sm-12">
        <Datepicker
            v-model="filters.endDate"
            position="down"
            :placeholder="$t('placeholder.end_date')"/>
      </div>
      <div class="col-lg-1 col-md-2 col-sm-4">
        <BaseCheckbox
            v-model="filters.withMessage"
            :label="$t('general.with_message')"
            :labelPosition="'right'"
            :inputStyle="{ transform: 'scale(1.2)' }"/>
      </div>
    </div>
  </form>
</template>

<script setup>
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import BaseInput from '@/components/base/BaseInput.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import {defineEmits, defineProps, toRefs} from 'vue';
import SearchButton from "@/components/button/SearchButton.vue";

const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
  coachDropdown: {
    type: Array,
    required: true,
  },
  statusDropdown: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['search']);

// Use toRefs to maintain reactivity
const {filters} = toRefs(props);
const coachDropdown = toRefs(props)['coachDropdown'];
const statusDropdown = toRefs(props)['statusDropdown'];

function onSearch() {
  emit('search', 1, undefined, filters.value);
}
</script>

<style scoped>
</style>
